<template>
  <div class="video-list-content">
    <tip></tip>
    <template v-if="videoObj.enable">
      <empty></empty>
    </template>
    <template v-else>
      <div class="video-content">
        <bVideo
            v-if="isInitPlay"
            ref="bVideo"
            :videoId="videoId"
            :playerOptions="playerOptions">
        </bVideo>
      </div>
      <div class="text-content">
        <div class="title">
          <h3 v-if="videoObj.name">{{ videoObj.name.slice(0,15) }}</h3>
        </div>
        <div class="header-img">
          <img :src="videoObj.author_pic" alt="">
          <div v-if="videoObj.author_name" class="header-title">{{ videoObj.author_name.slice(0,15) }}</div>
          <div class="buylink" v-if="videoObj.buy_link" @click="toBuy(videoObj.buy_link)">
            {{ videoObj.buy_title || '购买此书' }}
          </div>
        </div>
        <div class="synopsis">
          <p class="synopsis-text" v-if="videoObj.intro">简介：{{videoObj.intro}}</p>
          <p class="synopsis-text" v-else>简介：该视频目前没有更加详细的介绍</p>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from '@/components/empty.vue'
import bVideo from '@/components/bVideo.vue';
import { Indicator } from 'mint-ui';
import wechat from "@/plugins/wx";
  export default {
    components: {
      tip,
      bVideo,
      empty,
    },
    data() {
      return {
        isInitPlay: false,
        iszhankai: false,
        topVideo: false,
        topVideoObj: {},
        bottomVideo: true,
        bottomVideoObj: {},
        playerOptions: {
          //是否显示控制栏
          controls: true,
          language: 'en',
          sources: [
            {
            type: "video/mp4",
            src: "http://ayerdudu.sunnyint.net/video/2.mp4"
          }
          ],
          poster: "/static/images/author.jpg",
          playbackRates: [0.7, 1.0,1.25, 1.5, 2.0,3.0],
        },
        itemVideoObj:{},
        videoObj:{},
        videoList:[],
        index: 0,
        videoId: 0,
        loadFlag: true,
        itemList: [],
        shareConfig: {
          title: '分享标题',
          desc: '这是一个测试的微信分享',
          link: '', // 分享链接
          imgUrl: '', // 分享图标
        },
      }
    },
    created () {
      const id = this.$route.query.id || 1
      this.getVideoList()
      this.report(id,4)
    },
    methods: {
      async report(id,dt) {
        try {
          // 发送点击事件请求到服务端
          await this.$report.sendReport({
            "id": id,
            "dt":dt
          });

        } catch (error) {
          console.error("Error sending click request:", error);
        }
      },
      toBuy(link){
        window.open(link, '_blank');
      },
      zhankaiFn(){
        this.iszhankai = !this.iszhankai
      },
      changeVidelList(index){
        this.itemList = []
        this.index = index
        setTimeout(() => {
          this.itemList = this.videoList[index].items
        }, 0)
      },
      async getVideoList() {
        try {
          Indicator.open()
          const id = this.$route.query.id || 1
          this.videoId = id
          //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/vd_${id}.html`)
          const res = await this.axios.get(`https://api.ayerdudu.com/v1/video/d/${id}`)
          this.videoObj = res.data.data;
          const currentUrl = window.location.href.split('#')[0];
          this.shareConfig.title = this.videoObj.name;
          this.shareConfig.desc = this.videoObj.intro;
          this.shareConfig.link = currentUrl;
          this.shareConfig.imgUrl = this.videoObj.cover_pic;
          console.log('分享配置',this.shareConfig);
          //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
          wechat.initConfig(currentUrl).then(() => {
            // 配置分享内容
            wechat.setShareOptions(this.shareConfig);
          });
          this.palyItemVideo(res.data.data)
          Indicator.close()
        } catch (err) {
          Indicator.close()
          console.log(err)
        }
      },
      palyItemVideo(item, play=false){
         if(this.playerOptions.poster === item.cover_pic && this.$refs.bVideo.play){
          return
        } 
       
        this.isInitPlay = false
        this.playerOptions = {
          // muted: true,
          //是否显示控制栏
          controls: true,
          timeDivider: false,
          language: 'en',
          sources: [
            {
            type: "video/mp4",
            src: item.url
          }
          ],
          poster: item.cover_pic,
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true // 全屏按钮
          },
          playbackRates: [0.7, 1.0,1.25, 1.5, 2.0,3.0],
        }
        this.isInitPlay = true
        if(play){
          setTimeout(() => {
            this.$refs.bVideo.player.play()
            this.$refs.bVideo.play = true
          }, 100)
          
        }
      }
    },
    
  }
</script>

<style lang="less" scoped>
.video-list-content{
  min-height: 100%;
  background: #fff;
}
.video-content{
  height: 420px;
  width: 100%;
  background: #000;
  overflow: hidden;
  border-bottom: 1px solid #bfbfbf;
  video{
    width: 100%;
    height: 100%;
  }
}
.title{
  margin-top: 30px;
  margin-bottom: 34px;
  h3{
    font-size: 36px;
    line-height: 54px;
    font-weight: bold;
  }
}
.header-img{
  width: 100%;
  height: 66px;
  display: flex;
  margin-bottom: 22px;
  img{
    width: 66px;
    height: 66px;
    margin-right: 18px;
    border-radius: 50%;
    box-shadow: 1px solid #bfbfbf;
  }
  .header-title{
    flex: 1;
    line-height: 68px;
    font-size: 26px;
    color: #202020;
  }
  .buylink{
    padding: 16px 24px;
    border-radius: 40px;
    color: #f6451b;
    font-size: 24px;
    border: 2px solid #f6451b;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
  }
}
.text-content{
  box-sizing: border-box;
  width: 100%;
  padding: 0 30px;
  background: #fff;
}
.synopsis{
  font-size: 24px;
  color: #888;
  line-height: 38px;
  display: flex;
  padding: 0 0 24px 0;

  >p{
    flex: 1;
    &.zhankai{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  >span{
    width: 40px;
    position: relative;
    cursor: pointer;
    >img{
      width: 40px;
      height: 40px;
      position: absolute;
      bottom: 0;
    }
    

  }
}

.list-content{
  background: #f6f6f6;
  width: 100%;
  min-height: 200px;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  padding-bottom: 40px;
  .xuanji{
    display: flex;
    height: 46px;
    padding-left: 38px;
    padding-top: 46px;
    h3{
      font-size: 34px;
      color: #000;
      font-weight: bold;
      margin-right: 34px;
    }
    ul{
      flex: 1;
      overflow: hidden;
      white-space:nowrap;
      overflow-x:scroll;
      &::-webkit-scrollbar {
        display:none
      }
      .li-item{
        display: inline-block;
        margin-right: 24px;
        line-height: 46px;
        padding: 0 24px;
        line-height: 46px;
        background: #fff;
        color: #202020;
        font-size: 26px;
        border-radius: 24px;
        &.active{
          color: #f6451b;
          background: rgba(246,69,27, 0.15);
        }
      }
      .width20{
        display: inline-block;
        width: 200px;
      }
    }
  }
}
.item-box{
  margin-top: 28px;
  height: 270px;
  width: 100%;
  padding-left: 38px;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .width20{
    display: inline-block;
    height: 268px;
    width: 40px;
  }
  .item-list{
    display: inline-block;
    height: 268px;
    width: 254px;
    overflow: hidden;
    border-radius: 10px;
    margin-right: 24px;
    background: #fff;

    .cover_pic{
      display: block;
      width: 100%;
      height: 160px;
      position: relative;
      overflow: hidden;
      img{
        width: 100%;
        height: 1005;
      }
    }
    .name{
      font-size: 26px;
    }
    .item-name{
      box-sizing: border-box;
      display: inline-block;
      overflow: hidden;
      padding: 16px;
      height: 85px;
      font-size: 24px;
      line-height: 38px;
      white-space: normal;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .mengceng{
      display: none;
    }
    &.active{
      .item-name{
        color: #f6451b;
      }
      .mengceng{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background:rgba(0, 0, 0, 0.25);
      }
    }
  }
  
}
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 60px;
  text-align: center;
  font-size: 10px;
  margin-left: -20px;
  margin-top: -25px;
}
 
.spinner > div {
  background-color: #fff;
  height: 100%;
  width: 6px;
  display: inline-block;
  margin-right: 5px;
  border-radius: 10px;
   
  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
}
 
.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
 
.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

 
@-webkit-keyframes stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) } 
  20% { -webkit-transform: scaleY(0.8) }
}
 
@keyframes stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(0.8);
    -webkit-transform: scaleY(0.8);
  }
}

</style>